import { render, staticRenderFns } from "./AccountingItem.vue?vue&type=template&id=22a5c9a0&scoped=true"
import script from "./AccountingItem.vue?vue&type=script&lang=js"
export * from "./AccountingItem.vue?vue&type=script&lang=js"
import style0 from "./AccountingItem.vue?vue&type=style&index=0&id=22a5c9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a5c9a0",
  null
  
)

export default component.exports